class ExpandableText {
    constructor(container, blockName = 'expandable-text') {
        this.blockName = blockName;
        this.container = container;
        this.content = container.querySelector('[data-expandable-content]');
        this.button = container.querySelector('[data-expand-toggle]');
        this.maxLines = parseInt(container.dataset.maxLines) || 4;
        this.isExpanded = false;
        
        this.init();
    }
    
    init() {
        this.content.style.webkitLineClamp = this.maxLines;

        this.checkIfNeeded();
        this.button.addEventListener('click', () => this.toggle());

        window.addEventListener('resize', () => this.checkIfNeeded());
    }
    
    checkIfNeeded() {
        const lineHeight = this.getLineHeight();
        const maxHeight = lineHeight * this.maxLines;
        const needsButton = this.content.scrollHeight > maxHeight;
        
        if (needsButton) {
            this.button.classList.add(`${this.blockName}__toggle--visible`);
        } else {
            this.button.classList.remove(`${this.blockName}__toggle--visible`);
            // Если кнопка скрыта, убедимся что контент развернут
            this.collapse();
        }
    }
    
    getLineHeight() {
        // Пытаемся вычислить реальный line-height
        const computedStyle = getComputedStyle(this.content);
        let lineHeight = parseInt(computedStyle.lineHeight);
        
        // Если line-height normal, используем примерное значение
        if (isNaN(lineHeight) || lineHeight === 0) {
            const fontSize = parseInt(computedStyle.fontSize);
            lineHeight = Math.round(fontSize * 1.5);
        }
        
        return lineHeight;
    }
    
    toggle() {
        this.isExpanded ? this.collapse() : this.expand();
    }
    
    expand() {
        this.content.classList.add(`${this.blockName}__content--expanded`);
        this.button.textContent = 'свернуть';
        this.isExpanded = true;
    }
    
    collapse() {
        this.content.classList.remove(`${this.blockName}__content--expanded`);
        this.button.textContent = 'еще';
        this.isExpanded = false;
    }
}